import { useState, lazy, Suspense } from 'react'
import { useMemorama } from '../../context/MemoramaContext'
import { useLanguage } from '@context/LanguageContext'
import styles from './StartGameButton.module.css'

const AvatarValidationDialog = lazy(() => import('@shared/components/dialogs/AvatarValidationDialog'))

export default function StartGameButton ({ setSelectingAvatarFor, isDisabled = false }) {
  const { players, startGame, setPlayers } = useMemorama()
  const { t } = useLanguage()
  const [showAvatarDialog, setShowAvatarDialog] = useState(false)
  const [playerNeedingAvatar, setPlayerNeedingAvatar] = useState(null)

  const handleStartGame = () => {
    if (isDisabled) return
    if (!players || players.length === 0) return

    // Check for players without avatar and without warning flag
    const playersNeedAvatar = players.filter(player => !player.avatar && !player.warningShown)

    if (playersNeedAvatar.length > 0) {
      setPlayerNeedingAvatar(playersNeedAvatar[0])
      setShowAvatarDialog(true)
      return
    }

    startGame()
  }

  const handleContinueWithoutAvatar = () => {
    // Mark that warning was shown for this player
    setPlayers(prev => prev.map(player => {
      if (player.id === playerNeedingAvatar.id) {
        return { ...player, warningShown: true }
      }
      return player
    }))

    const remainingPlayers = players.filter(player =>
      player.id !== playerNeedingAvatar.id && !player.avatar && !player.warningShown
    )

    if (remainingPlayers.length > 0) {
      setPlayerNeedingAvatar(remainingPlayers[0])
    } else {
      setShowAvatarDialog(false)
      setPlayerNeedingAvatar(null)
      startGame()
    }
  }

  const handleSelectAvatar = () => {
    setShowAvatarDialog(false)
    setSelectingAvatarFor(playerNeedingAvatar.id)
    setPlayerNeedingAvatar(null)
  }

  const handleCloseDialog = () => {
    setShowAvatarDialog(false)
    setPlayerNeedingAvatar(null)
  }

  return (
    <>
      <button
        type='button'
        onClick={handleStartGame}
        className={styles.startGameButton}
        disabled={isDisabled}
      >
        {t.memorama.buttons.startGame}
      </button>

      {showAvatarDialog && playerNeedingAvatar && (
        <Suspense fallback={null}>
          <AvatarValidationDialog
            player={playerNeedingAvatar}
            onContinue={handleContinueWithoutAvatar}
            onSelectAvatar={handleSelectAvatar}
            onClose={handleCloseDialog}
          />
        </Suspense>
      )}
    </>
  )
}
